module.exports = __webpack_public_path__ + "static/img/身份证正面示例.cae698a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/身份证正面示例.jpg
// module id = aMwb
// module chunks = 0